/* eslint-disable prefer-const */
import React from 'react';
import parse from 'html-react-parser';
// import { Link } from 'gatsby';
import SearchForm from '@ecs/tng-common/components/search-form/SearchForm';
import Image from '@ecs/tng-common/components/image/Image';
import { sharedIconsPath } from '@ecs/tng-common/scripts/data';
import { imageWithPrefix } from '@ecs/tng-common/scripts/helpers';
import { IFontIconCard } from '@ecs/tng-common/interfaces';
import { themes, backgroundType } from '../helpers/interfaces';
import { returnTexturedClass, returnThemeBg } from '../helpers/functions';
import ROUTES from '../helpers/routes';

type HeroSectionProps = {
  content: IFontIconCard[];
  heading: string;
  subheading?: string;
  theme: themes;
  background?: backgroundType;
  showSearch?: boolean;
};
export default class HeroSection extends React.Component<HeroSectionProps> {
  render() {
    const { heading, theme, background, content, subheading, showSearch } = this.props;

    // Determine the class name based on the length of the cards array
    const setRowClassName = (cardsLength: number) => {
      let rowClassName = '';
      switch (cardsLength) {
        case 6:
          rowClassName = 'row-cols-md-3 px-md-6 px-lg-9 mx-xl-9';
          break;
        case 10:
          rowClassName = 'row-cols-lg-5 px-md-9 px-lg-0';
          break;
        case 4:
        case 8:
        default:
          rowClassName = 'row-cols-lg-4 px-md-9 px-lg-0';
          break;
      }
      return rowClassName;
    };
    return (
      <section
        className={`hero-component ${returnTexturedClass(theme, background === 'textured')} ${returnThemeBg(theme)}`}>
        <div className="container container-sm-py">
          <div
            className={`text-sm-center ${content && Object.keys(content).length > 0 ? 'content-mb' : ''}`}>
            <h1>{parse(heading)}</h1>
            {subheading && (
              <p
                className={`${theme === 'dark' ? 'text-white text-opacity-70' : 'text-gray'} h4 ${content && Object.keys(content).length > 0 ? '' : 'mb-0'}`}>
                {parse(subheading)}
              </p>
            )}
          </div>

          {content?.length > 0 ? (
            <div
              className={`row row-cols-2 ${setRowClassName(content?.length || 0)} gy-3 gy-md-4 d-flex ${content.length < 5 ? 'justify-content-md-center' : 'justify-content-start'}`}>
              {/*    // REPLACE WITH GATSBY LINK */}
              {content.map((item: IFontIconCard, index: number) => {
                return (
                  <div
                    className="col"
                    key={`heroCard_${index + 1}`}>
                    <a
                      href={ROUTES.CATEGORY.toUrl(item?.link || '#')}
                      className={`card card-link ${theme === 'dark' ? 'card-dark' : 'card-light'} flex-column align-items-center`}>
                      {item?.icon && (
                        <Image
                          className="spot-icon-md mb-3"
                          src={imageWithPrefix(`${sharedIconsPath}/${item.icon}.svg`)}
                          width="48"
                          height="48"
                          alt={`${item.heading} icon`}
                        />
                      )}
                      <h2 className="h6 mb-0 text-center">{item.heading}</h2>
                    </a>
                  </div>
                );
              })}
            </div>
          ) : null}
          {showSearch && (
            <div className="content-mt row justify-content-center">
              <div className="col-12 col-md-10 col-lg-8 col-xl-6">
                <SearchForm
                  toShowSecurityMessage={false}
                  toShowCopyOnFocus={false}
                  ifFocusableOnLoad={false}
                  className="rounded-circle overflow-hidden"
                  id="hmp-search-form"
                  placeholder="What else can we help you find?"
                />
              </div>
            </div>
          )}
        </div>
      </section>
    );
  }
}
